import React, { Component } from 'react';
import './AdminPackage.css'; // You can create a CSS file for styling

class VerticalTabsScrollable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0, // Set the initial active tab
    };
    this.tabRefs = Array(this.props.tabs.length).fill(React.createRef());
  }

  componentDidMount() {
    this.attachScrollListener();
  }

  componentWillUnmount() {
    this.detachScrollListener();
  }

  attachScrollListener() {
   this.tabRefs[this.state.activeTab].current.addEventListener('scroll', this.handleScroll);
  }

  detachScrollListener() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    const { tabs } = this.props;
    const { activeTab } = this.state;

    if (event.deltaY > 0 && activeTab < tabs.length - 1) {
      this.setState({ activeTab: activeTab + 1 });
    } else if (event.deltaY < 0 && activeTab > 0) {
      this.setState({ activeTab: activeTab - 1 });
    }
  };

  render() {
    const { tabs } = this.props;
    const { activeTab } = this.state;

    return (
      <div className="vertical-tabs dayplan-container" >
        <div className="tab-navigation dayplan-nav" data-testid="dayplan-nav">

        <p className="pointer-list-title" style={this.props.pointerListTitleStyle ? this.props.pointerListTitleStyle : {}}>Itinerary</p>
        <ul className="pointer-list" style={this.props.pointerListStyle ? this.props.pointerListStyle : {}}>
          {tabs.map((tab, index) => (
            <li
              key={index}
              className={`tab ${index === activeTab ? 'active' : ''}`}
              onClick={() => this.setState({ activeTab: index })}
              ref={this.tabRefs[index]}
            >
              {tab.label}
            </li>
          ))}
          </ul>
        </div>
        <div className="tab-content dayplan-details" style={{ paddingBottom: 0 }} ref={this.tabRefs[activeTab]}>
          {tabs[activeTab].content}
        </div>
      </div>
    );
  }
}

export default VerticalTabsScrollable;
